import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-catalogue-felix-oliver',
  templateUrl: './catalogue-felix-oliver.component.html',
  styleUrls: ['./catalogue-felix-oliver.component.css']
})
export class CatalogueFelixOliverComponent implements OnInit {

  movies: MovieModel[] = [];
  loading: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private moviesService: MoviesService, private router: Router) { }

  ngOnInit(): void {
    this.loading = true;

    this.moviesService.GetFelixOliverOnlineMovies().subscribe(
      (resp) => {
        this.loading = false;

        if (resp.length > 0) {
          this.movies = resp;
        }
      },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');

      },
    );
  }

  goMovie(idMovie) {
    this.router.navigate(['/movie', idMovie]);
  }

}
